import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Info from "../../../../assets/info.png";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import Loader from "../../../UI Component/Loader/Loader";
import afternoonIcon from "../assets/afternoon_sun.svg";
import morningIcon from "../assets/morning_sun.svg";
import eveningIcon from "../assets/night_moon.svg";

import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { USER_ROLE, USER_TYPE } from "../../../../Util/constants";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";

export default function Slots(props) {
  const { selected_date, consultation_typeId, counter, staffDoctor } = props;
  // Input parameters through props

  const [midnightSlots, setMidnightSlots] = useState([]);
  const [morningTimeSlots, setMorningTimeSlots] = useState([]);
  const [afternoonTimeSlots, setAfternoonTimeSlots] = useState([]);
  const [eveningTimeSlots, setEveningTimeSlots] = useState([]);
  const [loader, setLoader] = useState(false);

  const doctor_context = useContext(DoctorContext);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );

  useEffect(() => {
    let doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
    if (
      (doctorClinicAssociation === "true" ||
        staffClinicAssociation === "true") &&
      doctor_context?.clinic_id
    ) {
      // setLoader(true);
      afterLoginApiAxios({
        method: "post",
        url: "/clinic/get-appointments-slots-by-doctor-id",
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          doctor_id:
            doctorRole === USER_ROLE.DOCTOR_ADMIN ||
            doctorRole === USER_ROLE.RESOURCE_ADMIN ||
            userType === USER_TYPE.STAFF
              ? staffDoctor.id
              : userId,
          date: selected_date,
          consultation_type: consultation_typeId.id,
          procedure_id:
            consultation_typeId.id == "4" ? consultation_typeId.value : "",
          clinic_id: doctor_context?.clinic_id,
        },
      })
        .then((response) => {
          C2CConsole.log(response);
          if (response.data) {
            if (response.data.statusCode === 200) {
              let slots = response.data.time_slots.filter(
                (sl) => !sl.is_walkin
              );
              prepareTimeSlotsByCategories(slots);
            } else {
              setMidnightSlots([]);
              setMorningTimeSlots([]);
              setAfternoonTimeSlots([]);
              setEveningTimeSlots([]);
            }
          }
          setLoader(false);
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    } else {
      // setLoader(true);
      afterLoginApiAxios({
        method: "post",
        url: "/public/get-appointments-slots-by-doctor-id",
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          user_type: userType,
          doctor_id: userType === USER_TYPE.DOCTOR ? userId : staffDoctor.id,
          date: selected_date,
          consultation_type: consultation_typeId.id,
          procedure_id:
            consultation_typeId.id === "4" ? consultation_typeId.value : "",
        },
      })
        .then((response) => {
          if (response.data) {
            if (response.data.statusCode === 200) {
              let slots = response.data.time_slots.filter(
                (sl) => !sl.is_walkin
              );
              prepareTimeSlotsByCategories(slots);
            } else {
              setMidnightSlots([]);
              setMorningTimeSlots([]);
              setAfternoonTimeSlots([]);
              setEveningTimeSlots([]);
            }
          }
          setLoader(false);
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    }
  }, [selected_date, consultation_typeId, counter, doctor_context?.clinic_id]); //doctorId,

  function prepareTimeSlotsByCategories(timeSlots) {
    setMidnightSlots(getTimeSlotsByCategory("midnight", timeSlots));
    setMorningTimeSlots(getTimeSlotsByCategory("morning", timeSlots));
    setAfternoonTimeSlots(getTimeSlotsByCategory("afternoon", timeSlots));
    setEveningTimeSlots(getTimeSlotsByCategory("evening", timeSlots));
  }

  function getTimeSlotsByCategory(category, timeSlots) {
    const category_start_time = getStartTimeByCategory(category);
    const category_end_time = getEndTimeByCategory(category);

    return timeSlots.filter(
      (t) =>
        moment(
          `${selected_date} ${t.start_time}`,
          "YYYY-MM-DD h:mm a"
        ).isSameOrAfter(moment(category_start_time, "YYYY-MM-DD h:mm a")) && //selectedDate
        moment(
          `${selected_date} ${t.end_time}`,
          "YYYY-MM-DD h:mm a"
        ).isSameOrBefore(moment(category_end_time, "YYYY-MM-DD h:mm a"))
    ); //selectedDate
  }

  function getStartTimeByCategory(category) {
    switch (category) {
      case "midnight":
        return `${selected_date} 12:00 AM`; //selectedDate
      case "morning":
        return `${selected_date} 06:00 AM`; //selectedDate
      case "afternoon":
        return `${selected_date} 12:00 PM`; //selectedDate
      case "evening":
        return `${selected_date} 06:00 PM`; //selectedDate
      default:
        break;
    }
  }

  function getEndTimeByCategory(category) {
    switch (category) {
      case "midnight":
        return `${selected_date} 06:00 AM`; //selectedDate
      case "morning":
        return `${selected_date} 12:00 PM`; //selectedDate
      case "afternoon":
        return `${selected_date} 06:00 PM`; //selectedDate
      case "evening":
        return `${selected_date} 11:59 PM`; //selectedDate
      default:
        break;
    }
  }

  function handleSlotSelection(evt) {
    const selectedSlotId = evt.target.dataset.slotid;
    document.querySelectorAll("button[data-slotid]").forEach((slot) => {
      if (slot.dataset.slotid === selectedSlotId) {
        if (slot.classList.contains("selected")) {
          slot.classList.remove("selected");
        } else {
          slot.classList.add("selected");
        }
      }
    });

    props.getSelectedSlotCallback(selectedSlotId);
  }

  const TextOnlyTooltip = withStyles({
    tooltip: {
      bottom: "2px",
      color: "black",
      backgroundColor: "white",
      fontSize: "16px",
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    },
  })(Tooltip);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <section className="slot-wrapper">
          <div className="row px-3">
            <div className="col-12">
              <div className="d-flex flex-row font-weight-bold calander-heading">
                NOTE: Manage Your Slot
                <div>
                  <TextOnlyTooltip title="You can select time slots for which you are unavailable. Your patients will not be able to book appointments for these time slots.">
                    <span>
                      <img className="ml-2" src={Info} alt="" />
                    </span>
                  </TextOnlyTooltip>
                </div>
              </div>
            </div>
            <div className="col-12 d-flex flex-row justify-content-center ml-4">
              <ul className="mr-2 indicator-available">
                <li>
                  <span>Available</span>
                </li>
              </ul>
              <ul className="indicator-booked">
                <li>
                  <span>Booked</span>
                </li>
              </ul>
            </div>
          </div>
          {midnightSlots.length > 0 ||
          morningTimeSlots.length > 0 ||
          afternoonTimeSlots.length > 0 ||
          eveningTimeSlots.length > 0 ? (
            <>
              {midnightSlots.length > 0 ? (
                <div className="row mt-4">
                  <div className="col-12 text-center category-heading">
                    <img src={morningIcon} alt="Morning" />
                    <span className="ml-2">
                      Midnight: 12:00 AM &ndash; 6:00 AM
                    </span>
                  </div>
                  {/* {
                    morningTimeSlots.length > 0
                    ? */}
                  <div className="col-12 d-flex flex-wrap justify-content-center">
                    {midnightSlots.map((slot, index) => (
                      <button
                        key={index}
                        data-slotid={slot.id}
                        onClick={handleSlotSelection}
                        className="btn btn-sm mr-2 mt-3 py-2"
                      >
                        {slot.start_time}&nbsp;&nbsp;&ndash;&nbsp;&nbsp;
                        {slot.end_time}
                      </button>
                    ))}
                  </div>
                  {/* :
                    <div className="col-12 mt-3">
                        <div class="alert alert-danger text-center" role="alert">
                            No slots found for this duration
                        </div>
                    </div>
                } */}
                </div>
              ) : null}
              {morningTimeSlots.length > 0 ? (
                <div className="row mt-4">
                  <div className="col-12 text-center category-heading">
                    <img src={morningIcon} alt="Morning" />
                    <span className="ml-2">
                      Morning: 6:00 AM &ndash; 12:00 PM
                    </span>
                  </div>
                  {/* {
                    morningTimeSlots.length > 0
                    ? */}
                  <div className="col-12 d-flex flex-wrap justify-content-center">
                    {morningTimeSlots.map((slot, index) => (
                      <button
                        key={index}
                        data-slotid={slot.id}
                        onClick={handleSlotSelection}
                        className="btn btn-sm mr-2 mt-3 py-2"
                      >
                        {slot.start_time}&nbsp;&nbsp;&ndash;&nbsp;&nbsp;
                        {slot.end_time}
                      </button>
                    ))}
                  </div>
                  {/* :
                    <div className="col-12 mt-3">
                        <div class="alert alert-danger text-center" role="alert">
                            No slots found for this duration
                        </div>
                    </div>
                } */}
                </div>
              ) : null}
              {afternoonTimeSlots.length > 0 ? (
                <div className="row mt-5">
                  <div className="col-12 text-center category-heading">
                    <img src={afternoonIcon} alt="Afternoon" />
                    <span className="ml-2">
                      Afternoon: 12:00 PM &ndash; 6:00 PM
                    </span>
                  </div>
                  {/* {
                    afternoonTimeSlots.length > 0
                        ? */}
                  <div className="col-12 d-flex flex-wrap justify-content-center">
                    {afternoonTimeSlots.map((slot, index) => (
                      <button
                        key={index}
                        data-slotid={slot.id}
                        onClick={handleSlotSelection}
                        className="btn btn-sm mr-2 mt-3 py-2"
                      >
                        {slot.start_time}&nbsp;&nbsp;&ndash;&nbsp;&nbsp;
                        {slot.end_time}
                      </button>
                    ))}
                  </div>
                  {/* :
                        <div className="col-12 mt-3">
                            <div class="alert alert-danger text-center" role="alert">
                                No slots found for this duration
                        </div>
                        </div>
                } */}
                </div>
              ) : null}
              {eveningTimeSlots.length > 0 ? (
                <div className="row mt-5">
                  <div className="col-12 text-center category-heading">
                    <img src={eveningIcon} alt="Evening" />
                    <span className="ml-2">
                      Evening: 6:00 PM &ndash; 12:00 AM
                    </span>
                  </div>
                  {/* {
                    eveningTimeSlots.length > 0
                        ? */}
                  <div className="col-12 d-flex flex-wrap justify-content-center">
                    {eveningTimeSlots.map((slot, index) => (
                      <button
                        key={index}
                        data-slotid={slot.id}
                        onClick={handleSlotSelection}
                        className="btn btn-sm mr-2 mt-3 py-2"
                      >
                        {slot.start_time}&nbsp;&nbsp;&ndash;&nbsp;&nbsp;
                        {slot.end_time}
                      </button>
                    ))}
                  </div>
                  {/* :
                        <div className="col-12 mt-3">
                            <div class="alert alert-danger text-center" role="alert">
                                No slots found for this duration
                        </div>
                        </div>
                } */}
                </div>
              ) : null}
            </>
          ) : (
            <div className="col-12 mt-3">
              <div className="alert alert-danger text-center" role="alert">
                No slots available
              </div>
            </div>
          )}
        </section>
      )}
    </>
  );
}
